<template>
  <div class="content">
    <report-filter :reload-report="reloadReport" :loading="loading" :to-date-only="true"/>

    <div class="col-md-8 ml-auto mr-auto">
      <h3 class="text-center">{{ $t('emvTapsSummaryReport.title') }}</h3>
      <p class="text-center mb-3 no-print">
        {{ $t('emvTapsSummaryReport.description') }}
      </p>
    </div>

    <div v-if="loading" v-loading="loading" class="row pt-5"/>

    <div v-if="loading === false && error" class="row mt-3">
      <div class="col-12">
        <base-alert type="danger">
          <strong>{{ $t(`generic.errorTitle`) }}</strong> {{ error }}
        </base-alert>
      </div>
    </div>

    <div v-if="loading === false && report" class="row">
      <div class="col-6">
        <card :title="$t('emvTapsSummaryReport.summary.title')">
          <table>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t('emvTapsSummaryReport.summary.generatedAt') }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ report.generated_at | time }}</h5></td>
            </tr>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t('emvTapsSummaryReport.summary.reportingToDate') }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ report.to | dateOnly }}</h5></td>
            </tr>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t(`emvTapsSummaryReport.summary.totalAmount`) }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ totalAmount | money }}</h5></td>
            </tr>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t(`emvTapsSummaryReport.summary.failedAmount`) }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ failedAmount | money }}</h5></td>
            </tr>
          </table>
        </card>
      </div>
    </div>


    <div v-if="report" class="row mt-3">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title">{{ $t(`emvTapsSummaryReport.results.emvTapsSummaryTableLabel`) }}<small
            class="ml-2 text-muted">({{ report.to | dateOnly }})</small>
          </h4>
          <div>
            <el-table :data="report.data.emv_taps_summary"
                      :empty-text="$t('generic.emptyReportForThePeriod')"
                      show-summary
                      :summary-method="getJourneysCountTableTotal">
              <el-table-column :label="$t('emvTapsSummaryReport.results.status')">
                <template slot-scope="{ row }">{{ row.status }}</template>
              </el-table-column>
              <el-table-column :label="$t('emvTapsSummaryReport.results.taps_count')">
                <template slot-scope="{ row }">{{ row.taps_count }}</template>
              </el-table-column>
              <el-table-column :label="$t('emvTapsSummaryReport.results.taps_charge_sum')">
                <template slot-scope="{ row }">{{ row.taps_charge_sum | money }}</template>
              </el-table-column>
            </el-table>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapState} from "vuex";
import ReportFilter from "./ReportFilter";
import {Table, TableColumn} from 'element-ui';

export default {
  name: 'emv-taps-summary-report',
  components: {
    ReportFilter,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  computed: {
    ...mapState({
      loading: state => state.emv_taps_summary_report.loading,
      report: state => state.emv_taps_summary_report.data,
      error: state => state.emv_taps_summary_report.error,
    }),
    totalAmount() {
      let totalAmount = 0;
      for (var i = 0; i < this.report.data.emv_taps_summary.length; i++) {
        totalAmount += this.report.data.emv_taps_summary[i].taps_charge_sum
      }
      return totalAmount
    },
    failedAmount() {
      let totalAmount = 0;
      for (var i = 0; i < this.report.data.emv_taps_summary.length; i++) {
        if (this.report.data.emv_taps_summary[i].status == "clearing_failed" || this.report.data.emv_taps_summary[i].status == "payment_failed")
          totalAmount += this.report.data.emv_taps_summary[i].taps_charge_sum
      }
      return totalAmount
    },
  },
  methods: {
    ...mapActions(['GetEmvTapsSummaryReport']),
    reloadReport(query) {
      this.GetEmvTapsSummaryReport(query);
    },
    getJourneysCountTableTotal(param) {
      const {columns, data} = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = this.$t('emvTapsSummaryReport.results.summaryRow');
          return;
        }

        switch (index) {
          case 1:
            let values;
            values = data.map(item => Number(item.taps_count));

            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
            }
            break;
          case 2:
            let values1;
            values1 = data.map(item => Number(item.taps_charge_sum));

            let totalValue = 0;
            if (!values1.every(value => isNaN(value))) {
              totalValue = values1.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
            }

            sums[index] = this.$options.filters.money(totalValue)

            break;
          default:
            sums[index] = '';
        }
      });
      return sums;
    },
  }
};
</script>

